<div class="content">
  <div class="header">
    {{ 'strategies.pickHeader' | translate }}
  </div>
  <div class="btn-description">
    {{ 'strategies.setOwnInvestment' | translate }}
  </div>
  <div class="button-container">
    <libero-button
      (click)="routeToNew()"
      label="{{ 'global.buttons.createStrategy' | translate }}"
      btnClasses="btn--primary btn--big"
      data-cy="picker-new-strategy-button"
    ></libero-button>
  </div>
  <div class="description">
    {{ 'strategies.description' | translate }}
  </div>

  @if (!modelStrategiesPreloader) {
    <div class="swiper-container">
      <libero-model-strategy-carousel 
        [modelStrategies]="modelStrategies!" 
        [canCreateEfektika]="canCreateEfektika"
      ></libero-model-strategy-carousel>
    </div>
  } @else {
    <libero-preload-spinner></libero-preload-spinner>
  }
</div>